import { DisplayFormat, Segment } from './types';

export const ALLOWED_KEYS = [
  'Backspace',
  'Delete',
  'Tab',
  'Escape',
  'Enter',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
] as const;

export const SEGMENT_CONFIG: Record<
  Segment,
  {
    maxLength: number;
    placeholder: string;
    ariaLabel: string;
    widthClass: string;
  }
> = {
  year: {
    maxLength: 4,
    placeholder: 'YYYY',
    ariaLabel: 'Year',
    widthClass: 'w-10 flex-shrink-0 h-6',
  },
  month: {
    maxLength: 2,
    placeholder: 'MM',
    ariaLabel: 'Month',
    widthClass: 'w-7 flex-shrink-0 h-6',
  },
  day: {
    maxLength: 2,
    placeholder: 'DD',
    ariaLabel: 'Day',
    widthClass: 'w-7 flex-shrink-0 h-6',
  },
};

export const DATE_RANGES = {
  MIN_YEAR: 1000,
  MAX_YEAR: 9999,
  MIN_MONTH: 1,
  MAX_MONTH: 12,
  MIN_DAY: 1,
  MAX_DAY_FALLBACK: 31,
} as const;

export const INVALID_DATE_MESSAGE = 'Invalid date';
export const FUTURE_DATE_MESSAGE = 'Date cannot be in the future';

/**
 * Configuration for each display format.
 * - segmentOrder: The order in which segments appear in the UI
 * - separator: The character used between segments
 */
export const DISPLAY_FORMAT_CONFIG: Record<
  DisplayFormat,
  {
    segmentOrder: [Segment, Segment, Segment];
    separator: string;
  }
> = {
  iso: {
    segmentOrder: ['year', 'month', 'day'],
    separator: '-',
  },
  us: {
    segmentOrder: ['month', 'day', 'year'],
    separator: '/',
  },
  in: {
    segmentOrder: ['day', 'month', 'year'],
    separator: '/',
  },
};
